export default {
  BASE_PATH: process.env.REACT_APP_BASE_PATH!,
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID!,
  REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI!,
};
